/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_MaritalStatusDto } from '../models/PagedResultDto_MaritalStatusDto';
import type { Wealthlane_CustomerService_Dtos_MaritalStatus_CreateUpdateMaritalStatusDto } from '../models/Wealthlane_CustomerService_Dtos_MaritalStatus_CreateUpdateMaritalStatusDto';
import type { Wealthlane_CustomerService_Dtos_MaritalStatus_MaritalStatusDto } from '../models/Wealthlane_CustomerService_Dtos_MaritalStatus_MaritalStatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MaritalStatusService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_MaritalStatus_MaritalStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppMaritalStatusMaritalStatusList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_MaritalStatus_MaritalStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/marital-status/marital-status-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_MaritalStatus_MaritalStatusDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppMaritalStatus(
        requestBody?: Wealthlane_CustomerService_Dtos_MaritalStatus_CreateUpdateMaritalStatusDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_MaritalStatus_MaritalStatusDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/marital-status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_MaritalStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppMaritalStatus(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_MaritalStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/marital-status',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_MaritalStatus_MaritalStatusDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppMaritalStatus(
        id: string,
        requestBody?: Wealthlane_CustomerService_Dtos_MaritalStatus_CreateUpdateMaritalStatusDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_MaritalStatus_MaritalStatusDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/marital-status/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppMaritalStatus(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/marital-status/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_CustomerService_Dtos_MaritalStatus_MaritalStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppMaritalStatus1(
        id: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_MaritalStatus_MaritalStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/marital-status/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
